import {Component, ViewChild, HostListener, ElementRef, ChangeDetectorRef, ViewChildren, QueryList} from "@angular/core";
import {Reports, ReportsAccesses, ReportsParameters} from "../../models";
import {Filter, HttpService, FilterContracts, DepartmentsService} from "../../services";
import {BsModalComponent} from "ng2-bs3-modal/ng2-bs3-modal";
//import * as _ from 'underscore';
import {PagerService} from "../../services/index";
import {StringUtility} from "../../util/string.utility";
import {AgentUtility} from "../../util/agent.utility";
import {Router, ActivatedRoute, Params} from "@angular/router";
import {ReportsService} from "../../services/reports.service";
import {ResponseApi} from "../../services/response/response";
import { FormBuilder, FormGroup, FormArray, FormControl, ReactiveFormsModule, NgForm, FormsModule} from '@angular/forms';
import {Agent, Contract, Event, EventFilterDate, EventTypes, Product, StatusContract} from "../../models";
import {TreeUtil} from "../../util/tree";
import {retry} from "rxjs/operator/retry";
import {ContractsService} from "../../services/contracts.service";
import {AgentsService} from "../../services/agents.service";
import {EventFilter, EventsService} from "../../services/events.service";
import {AppSettings} from "../../app.settings";
import { NKDatetime } from 'ng2-datetime/ng2-datetime';
import { Subject, Observable, Observer } from 'rxjs';
import { WebSocketSubject } from 'rxjs/observable/dom/WebSocketSubject';
import { wsService} from './data.component';
import { WebsocketService } from "./websocket.services";



@Component({
    moduleId: module.id,
    selector: 'reports',
    templateUrl: 'reports.component.html',   
    styleUrls: ['reports.component.css'],
    providers: [ReportsService, PagerService, AgentsService, EventsService, DepartmentsService, wsService, WebsocketService]
})
export class ReportsComponent {
    reports: Reports[] = [];
    filteredReports: Reports[] = [];
    accesses: any = [];
    showLoadScreen: boolean = false;
    parameters: ReportsParameters[] =[];
    selectedUser:any;
    showParameters: Boolean = false;
    filterContracts: FilterContracts = new FilterContracts();
    filterEvents: EventFilter = new EventFilter();
    nodes: any[] = [];
    printReport: any = [];
    rowNum: number;    
    currentNodeId: number;
    currentNode:string;
    reportTypeId = 0;
    startHeaderId:number;
    departmentsCopy: any = [];
    startHeader:string;
    departments:any = [];
    agency:number;

    now:Date;
    datepickerOpts: any = {
        autoclose: true,
        todayHighlight: true,
        assumeNearbyYear: true,
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru',
        todayBtn: "linked",
        enableOnReadonly:false,
        endDate:new Date()
    };
    periodpickerOpts: any = {
        minViewMode:1,
        autoclose: true,
        todayHighlight: true,
        assumeNearbyYear: true,
        format: 'mm.yyyy',
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru',
        todayBtn: "linked",
        enableOnReadonly:false,
        endDate:new Date()
    };

    staticFilters = {
        rep_date_from:null,    
        rep_date_to:null,  
        rep_date:new Date(),      
        rep_date_period:null,
    };

    @ViewChildren(NKDatetime) datepickers:QueryList<NKDatetime>;


    pager: any = {};
    pagedItems: any[];
    pageSize: number = 20;
    totalItems: number;

    get ActiveNodes() {
        if(!this.selectedUser)
            return;
        return this.selectedUser.Name;
    }

    CalculatePeriod(){
        if(this.staticFilters.rep_date_period){
            this.staticFilters.rep_date_period.setDate(25);
            if(this.staticFilters.rep_date_period > this.now)
                this.staticFilters.rep_date_period = this.now
        }
        return;
    }

    InitDates(){
        this.staticFilters = {
            rep_date_from:null,    
            rep_date_to:null,  
            rep_date:new Date(),     
            rep_date_period:null,
        }
    }


    constructor(
        private reportsService: ReportsService
        , private pagerService: PagerService
        , private eRef: ElementRef
        , private router: Router
        , private formBuilder: FormBuilder
        , private agentService: AgentsService
        , private departmentService: DepartmentsService
        , private _ref:ChangeDetectorRef
        , private WsService: wsService) {
        this.reportsService.onStart = () => this.showLoadScreen = true;
        this.reportsService.onEnd = () => this.showLoadScreen = false;
        this.startHeaderId = AgentUtility.getUser().Id;
        this.startHeader = this.startHeaderId.toString();
        this.now = new Date();
        this.now.setHours(0,0,0,0);
    }
    
    ngOnInit() {
        this.connectToWs();
        this.InitDates();
        var id = AgentUtility.getUser().Id;
        this.agentService.getAgentTreeByFilter(id, {downOnly: true}).subscribe(res => {
            let data = res.data;
            data[0].isParent = true;
            this.selectedUser = data[0];
            this.nodes = data;
            //
        });

       this.currentNode = id.toString();

       this.reportsService.getReports(id).subscribe((data) => { this.reports = data.data; this.filteredReports = this.reports;});
       this.reportsService.getUserReportsAccesses(id).subscribe((data) => { this.InitAccesses(data.data);});
       this.departmentService.getMyDepartments(AgentUtility.getUser().Id).subscribe(data => {this.departments = data.data; this.departmentsCopy = data.data})
    }

    connectToWs(){   
        this.WsService.sendMsg( {type: 'client', id: AgentUtility.getUser().Id }); 
        this.WsService.messages.subscribe(msg => {

            var mess = msg.message;
            for (let element of this.reports) {

                if(element.id == msg.id) {
                    
                    element.Status = mess;
                }
            }

        });
    }

    sendMessage(){
        //this.WsService.sendMsg('Test MEssage');
    }

    ngAfterViewChecked(){
        this.datepickersOffAutocomplete();
    }
    
    InitAccesses(accesses:any[]){
        this.accesses = accesses;
    }



    active(node) {
        this.currentNodeId = node.data.Id;
        this.currentNode = this.currentNodeId.toString()
        this.selectedUser = node.data;
        let paramName = this.parameters.filter(p => p.Type == "START_HEADER_ID_MANUAL")[0].Name
        let filter = this.currentNodeId == AgentUtility.getUser().Id ? -1 : this.currentNodeId;
        this.filterByParameter(paramName,filter);
    }


    public onReportsTypeChange($event) {
       let selectedReportType = $event.target.value;
       if(selectedReportType == -1){
           this.showParameters = false;
           this.clearParameters();
           this.clearFilter();
           return;
       }
       this.InitDates();
       if(selectedReportType < 0)
           {this.showParameters = false;}
       else
       {
           this.showParameters = true;
           this.reportsService.getReportsParametersByType(selectedReportType).subscribe((data) => {
               this.parameters = data.data;
               var reportBrief = this.accesses.filter(element => element.ReportsType.id == selectedReportType)[0].ReportsType.Brief;
               //Убрать для данных типов Агентсва с статусом Отменен и Расторгнут
               if(reportBrief == "V_REP_DSF_UW_REP" || reportBrief == "V_REP_DSF_AGENT_PLAN_EXEC" || reportBrief == "V_REP_DSF_ADJUST_OF_DMG"){
                   this.departments = this.departmentsCopy.filter(element => element.DateClose == null);                  
               }
               else{
                    this.departments = this.departmentsCopy;
               }
            });      
       }
       this.filterByReportType(selectedReportType);
    }   

    clearParameters(){
        this.parameters = [];
    }

    clearFilter(){
        this.filteredReports = this.reports;
    }

    public onPostForPrintUID(id, row_no){
            this.rowNum = 0;
            this.reportsService.getReportById(id).subscribe(data => {this.printReport = data;if(this.printReport.status == 'OK')
            {
                var win = window.open(AppSettings.apiUrl + 'reports/getReportPrint/' + id, '_blank');
            }
            else
            {              
                this.rowNum = row_no + 1;
            }});            
    }

    public createReport(form: NgForm){       
        var params = [];      
        let request = {};

        if(!form.valid)
            return
        
        for(let value in form.value){
            if(value.startsWith("HIDDEN"))
                continue;
            let paramIndex:number = value.indexOf("REPORT_PARAM_");
            if(paramIndex > -1){
                let postValue = form.value[value] ? form.value[value].toString() : null;
                let postName = value.substring(paramIndex+13)
                if(postName == "REP_DATE" || postName == "REP_DATE_PERIOD")
                    postValue = postValue? postValue : this.formatDate(this.now)
                if(!postValue || postValue == "-1")
                    continue;
                params.push({
                    name:postName,
                    value:postValue
                });
            }
            else
                request[value] = form.value[value];
        }
        request['params'] = params;
        request['agentId'] = this.startHeaderId;

        this.reportsService.postManualReport(request).subscribe((data) => {
            this.reports = data.data.concat(this.reports)
            this.filteredReports = data.data.concat(this.filteredReports);
        });
    }

    formatDate(date:Date):string{
        return date? ('0'+date.getDate()).slice(-2)+"."+('0'+(date.getMonth()+1)).slice(-2)+"."+date.getFullYear().toString() : undefined;
    }

    filterByReportType(reportTypeId:number){
        this.reportTypeId = reportTypeId
        this.filteredReports = this.reports.filter(r => r.ReportsTypesId == reportTypeId)
    }

    getAgencyName(id:any):string{
        let ID:number = typeof(id) == typeof("")? parseInt(id) : typeof(id) == typeof(0)? id : undefined;
        if(ID == -1)
            return null;
        return this.departments.filter(d => d.Id == ID)[0].Name
    }

    filterByParameter(name:string,value:any){
        this.filterByReportType(this.reportTypeId);
        if(!value || value == -1)
            return;
        this.filteredReports = this.filteredReports.filter(r => r.Params.indexOf(name+":"+value) > -1)
    }

    datepickersOffAutocomplete(){
        this.datepickers.forEach(picker => {
            picker.datepicker[0].autocomplete = "off";
        })
    }
}
